import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=2bf1d6f0&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"
import style0 from "./Client.vue?vue&type=style&index=0&id=2bf1d6f0&lang=scss&scoped=true&"
import style1 from "./Client.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Client.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1d6f0",
  null
  
)

export default component.exports